module.exports = __webpack_public_path__ + "am.svg?cb2561270555c1b1e80318bc637c05ea";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/am.svg
// module id = 967
// module chunks = 0